import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { useMeasure, useScroll, useWindowSize } from 'react-use';

import { resolvePathname } from '@mssgme/helpers';
import styles from './ScrollableHorizontalCardMenu.scss';

function useMenuScroll(collectionsItems) {
    const list = useRef(null);
    const [activeLinkIndex, setActiveLinkIndex] = useState(0);
    const [root, { width }] = useMeasure();
    const { width: windowWidth } = useWindowSize();
    const { x: listScrollX } = useScroll(list);

    // TODO: create hook
    const isDesktop = windowWidth > 1024;
    const listScrollWidth = (list.current && list.current.scrollWidth) || width;
    const hasScroll = listScrollWidth > width;
    const hasLeftBtn = hasScroll && isDesktop && listScrollX > 0;
    const hasRightBtn = hasScroll && isDesktop && listScrollX + width < listScrollWidth;

    function moveLeft() {
        if (activeLinkIndex > 0) {
            const menuItems = Array.from(list.current.querySelectorAll('li')).slice(0, activeLinkIndex - 1);
            let itemsWidth = 0;
            menuItems.forEach((item) => {
                itemsWidth += item.clientWidth + 6;
            });
            list.current.scrollLeft = itemsWidth - 22;
            setActiveLinkIndex((prevActiveLinkIndex) => prevActiveLinkIndex - 1);
        } else {
            list.current.scrollLeft = 0;
        }
    }

    function moveRight() {
        if (activeLinkIndex < collectionsItems.length - 1) {
            const menuItems = Array.from(list.current.querySelectorAll('li')).slice(0, activeLinkIndex + 1);
            let itemsWidth = 0;
            menuItems.forEach((item) => {
                itemsWidth += item.clientWidth + 6;
            });
            list.current.scrollLeft = itemsWidth - 22;
            setActiveLinkIndex((prevActiveLinkIndex) => prevActiveLinkIndex + 1);
        } else {
            list.current.scrollLeft = listScrollWidth;
        }
    }

    return { root, hasLeftBtn, moveLeft, list, hasRightBtn, moveRight };
}

export default function ScrollableHorizontalCardMenu({ collectionsItems, baseUrl }) {
    const { root, hasLeftBtn, moveLeft, list, hasRightBtn, moveRight } = useMenuScroll(collectionsItems);

    return (
        <div className={styles.root} ref={root}>
            {hasLeftBtn && (
                <div className={styles.controlContainerLeft} onClick={moveLeft}>
                    <div className={styles.control}>
                        <FiChevronLeft size={20} />
                    </div>
                </div>
            )}
            <ul className={styles.list} ref={list}>
                {collectionsItems.map((col) => (
                    <li key={col.id} className={styles.item}>
                        <Link to={resolvePathname(baseUrl, '/c/', col.slug)}>{col.name}</Link>
                    </li>
                ))}
            </ul>
            {hasRightBtn && (
                <div className={styles.controlContainerRight} onClick={moveRight}>
                    <div className={styles.control}>
                        <FiChevronRight size={20} />
                    </div>
                </div>
            )}
        </div>
    );
}

ScrollableHorizontalCardMenu.propTypes = {
    collectionsItems: PropTypes.array.isRequired,
    baseUrl: PropTypes.string.isRequired,
};
